
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenQuad as ObiScreenQuadElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-quad.js';
 
 
 

 
 export const ObiScreenQuad = createComponent({
   react: React,
   tagName: 'obi-screen-quad',
   elementClass: ObiScreenQuadElement,
   events: {
     
   }
  });
 
 